import { Button } from 'antd'
import { CIMSButtonProps } from './types'
import { useDisabledOptions } from '../../hooks/useDisabledOptions'
import DisabledTooltip from '../DisabledTooltip'

/**
 * wraps an ant design {@link Button} with a {@link DisabledTooltip}
 *
 * feel free to add more functionality to this component as needs arise...
 */
const CIMSButton: React.FC<CIMSButtonProps> = ({
  loading,
  disabled,
  children,
  ...rest
}) => {
  const resolvedDisabled = Array.isArray(disabled) ? disabled : [disabled]
  const [disabledOptions, { some }] = useDisabledOptions([
    { disabled: !!loading, reason: 'loading' },
    ...resolvedDisabled,
  ])
  return (
    <DisabledTooltip disabled={disabledOptions}>
      <Button disabled={some || loading} loading={loading} {...rest}>
        {children}
      </Button>
    </DisabledTooltip>
  )
}

export default CIMSButton
